import { parseDayDepthChartWidgetInternalState } from 'src/pages/dashboard/features/well-day-depth-widget/parseDayDepthChartWidget';

import type { TSerializedWidget } from 'src/entities/workspace/types';
import type { DayDepthChartWidgetEntity } from 'src/pages/dashboard/features/well-day-depth-widget/DayDepthChartWidget.entity';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function dayDepthChartApplyChanges(
  widget: DayDepthChartWidgetEntity,
  changes: TSerializedWidget,
  index: number
) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseDayDepthChartWidgetInternalState(changes.internalState);

  widget.setWellId(internalState.wellId);
  widget.setStateParams(internalState.stateParams);
}
